import { spacing12 } from "@themes/spacing";

export const DEFAULT_BORDER_RADIUS_IN_REM = spacing12;
